const FBCLID_STORAGE_KEY = 'icaseoeste_fbclid';
const FBC_STORAGE_KEY = 'icaseoeste_fbc';

export function getCookie(name) {
  if (typeof document === 'undefined' || !document.cookie) {
    return null;
  }
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function readStorage(key) {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return localStorage.getItem(key);
  } catch (_) {
    return null;
  }
}

function writeStorage(key, value) {
  if (typeof window === 'undefined' || value == null) {
    return;
  }
  try {
    localStorage.setItem(key, value);
  } catch (_) {
    /* ignore */
  }
}

function buildFbcFromFbclid(fbclid, createdAtMs = Date.now()) {
  if (!fbclid) {
    return null;
  }
  return `fb.1.${createdAtMs}.${fbclid}`;
}

function fbcMatchesFbclid(fbc, fbclid) {
  if (!fbc || !fbclid) {
    return false;
  }
  return fbc.endsWith(`.${fbclid}`);
}

function persistFbcForFbclid(fbclid) {
  if (!fbclid) {
    return null;
  }
  const storedFbc = readStorage(FBC_STORAGE_KEY);
  if (fbcMatchesFbclid(storedFbc, fbclid)) {
    return storedFbc;
  }
  const fbc = buildFbcFromFbclid(fbclid);
  writeStorage(FBC_STORAGE_KEY, fbc);
  return fbc;
}

export function persistFbclidFromSearch(search = window.location.search) {
  if (typeof window === 'undefined') {
    return;
  }
  const params = new URLSearchParams(search);
  const fbclid = params.get('fbclid');
  if (!fbclid) {
    return;
  }
  writeStorage(FBCLID_STORAGE_KEY, fbclid);
  persistFbcForFbclid(fbclid);
}

function getStoredFbclid() {
  if (typeof window === 'undefined') {
    return null;
  }
  const fromUrl = new URLSearchParams(window.location.search).get('fbclid');
  if (fromUrl) {
    return fromUrl;
  }
  return readStorage(FBCLID_STORAGE_KEY);
}

export function getMetaClickIds() {
  const fbp = getCookie('_fbp');
  const fbcCookie = getCookie('_fbc');
  const fbclid = getStoredFbclid();
  if (fbcCookie) {
    return {
      fbp: fbp || null,
      fbc: fbcCookie,
      fbclid: fbclid || null,
    };
  }
  return {
    fbp: fbp || null,
    fbc: persistFbcForFbclid(fbclid),
    fbclid: fbclid || null,
  };
}
